import { z } from 'zod'

const jsonResponse = z.object({}).passthrough()

export const xanoProxyHealthResponseSchema = jsonResponse
export const xanoProxyInternalResponseSchema = jsonResponse
export const xanoProxyWebhookResponseSchema = jsonResponse
export const uploadsHealthResponseSchema = jsonResponse
export const uploadsStorageReadinessResponseSchema = jsonResponse
export const supportMcpHealthResponseSchema = jsonResponse
export const mcpserverHealthResponseSchema = jsonResponse

export type XanoProxyHealthResponse = z.infer<typeof xanoProxyHealthResponseSchema>
export type XanoProxyInternalResponse = z.infer<typeof xanoProxyInternalResponseSchema>
export type XanoProxyWebhookResponse = z.infer<typeof xanoProxyWebhookResponseSchema>
export type UploadsHealthResponse = z.infer<typeof uploadsHealthResponseSchema>
export type UploadsStorageReadinessResponse = z.infer<typeof uploadsStorageReadinessResponseSchema>
export type SupportMcpHealthResponse = z.infer<typeof supportMcpHealthResponseSchema>
export type McpserverHealthResponse = z.infer<typeof mcpserverHealthResponseSchema>
